import { Icon } from "../Icon"

interface ChevronDownIconProps {
  size?: number
  className?: string
}

export const ChevronDownIcon = ({ size = 18, className }: ChevronDownIconProps) => {
  return (
    <Icon size={size} viewBox="0 0 20 20" className={className}>
      <path
        d="M5 8.50004L10 13.5L15 8.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
